// src/pages/ShipmentDetails.jsx
import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../services/firebase";

function fmtDate(ts) {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleString();
}

export default function ShipmentDetails() {
  const { id } = useParams();
  const [ship, setShip] = useState(null);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setMsg("");
      try {
        const snap = await getDoc(doc(db, "shipments", id));
        if (!snap.exists()) {
          setMsg("Shipping introuvable.");
        } else {
          setShip({ id: snap.id, ...snap.data() });
        }
      } catch (e) {
        console.error(e);
        setMsg("Erreur de chargement.");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const lines = useMemo(() => (Array.isArray(ship?.lines) ? ship.lines : []), [ship]);

  return (
    <div className="container py-3">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="m-0">Détails Shipping</h4>
        <div className="d-flex gap-2">
          <Link className="btn btn-outline-secondary btn-sm" to="/admin/shipments">← Retour</Link>
          {ship && (
            <Link className="btn btn-dark btn-sm" to={`/admin/shipments/${ship.id}/receive`}>Recevoir</Link>
          )}
        </div>
      </div>

      {loading ? (
        <div>Chargement…</div>
      ) : msg ? (
        <div className="alert alert-warning">{msg}</div>
      ) : !ship ? null : (
        <>
          <div className="card mb-3">
            <div className="card-body row g-3">
              <div className="col-12 col-md-6">
                <div className="mb-1"><span className="text-muted">ID:</span> <code>{ship.id}</code></div>
                <div className="mb-1"><span className="text-muted">Code:</span> {ship.code || "—"}</div>
                <div className="mb-1"><span className="text-muted">Statut:</span> <strong>{ship.status || "draft"}</strong></div>
              </div>
              <div className="col-12 col-md-6">
                <div className="mb-1"><span className="text-muted">Origine:</span> {ship.origin || "—"} · <span className="text-muted">Destination:</span> {ship.destination || "—"}</div>
                <div className="mb-1"><span className="text-muted">Créé:</span> {fmtDate(ship.createdAt)}</div>
                <div className="mb-1"><span className="text-muted">Expédié:</span> {fmtDate(ship.shippedAt)}</div>
                <div className="mb-1"><span className="text-muted">Reçu:</span> {fmtDate(ship.receivedAt)}</div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="table-responsive">
              <table className="table align-middle">
                <thead>
                  <tr>
                    <th>Article</th>
                    <th>PO</th>
                    <th className="text-end">Expédié</th>
                    <th className="text-end">Reçu</th>
                    <th className="text-end">Reste</th>
                  </tr>
                </thead>
                <tbody>
                  {lines.length === 0 ? (
                    <tr><td colSpan={5} className="text-muted">Aucune ligne</td></tr>
                  ) : (
                    lines.map((l, i) => {
                      const shipped = Number(l.qty || 0);
                      const rcvd = Number(l.rcvdQty || 0);
                      const rest = Math.max(0, shipped - rcvd);
                      return (
                        <tr key={`${l.itemId}-${l.poId || "nop"}-${i}`}>
                          <td>
                            <div className="fw-semibold">{l.name || l.itemId}</div>
                            <div className="small text-muted">{l.itemId}</div>
                          </td>
                          <td className="small">{l.poId || <span className="text-muted">—</span>}</td>
                          <td className="text-end">{shipped.toLocaleString()}</td>
                          <td className="text-end">{rcvd.toLocaleString()}</td>
                          <td className="text-end fw-semibold">{rest.toLocaleString()}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
